// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"f276ea03","192":"6d24ad69","569":"87227691","773":"e14f1010","950":"cd8e05d4"}[chunkId] + ".chunk.js";
};